// Copyright (c) 2016 Deere & Company

import './dealer-percentage-item.scss';
import React, {PropTypes} from 'react';
import DealerPercentage from '@deere/cps-it.warranty-model-factory/lib/dealer-percentage';
import DealerPercentageItem from './dealer-percentage-item';

const DealerPercentageList = props =>
    <ul className='dealer-percentage-list'>
        {props.dealerPercentages.map(dealerPercentage =>
            <DealerPercentageItem
                dealerPercentage={dealerPercentage}
                key={dealerPercentage.account}
                targetCompletion={props.targetCompletion}
            />
        )}
    </ul>;

DealerPercentageList.displayName = 'DealerPercentageList';
DealerPercentageList.propTypes = {
    dealerPercentages: PropTypes.arrayOf(PropTypes.instanceOf(DealerPercentage)).isRequired,
    targetCompletion: PropTypes.number.isRequired
};

export default DealerPercentageList;



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-summary/dealer-percentage-list.js